var render, staticRenderFns
import script from "./NutritionGraph2D.vue?vue&type=script&lang=js&"
export * from "./NutritionGraph2D.vue?vue&type=script&lang=js&"
import style0 from "./NutritionGraph2D.vue?vue&type=style&index=0&id=4b06eb18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06eb18",
  null
  
)

export default component.exports